module.exports = __webpack_public_path__ + "static/media/sagnik.f6aa2c96.jpg";